export default __webpack_public_path__ + "static/media/6E8D67AB-9F60-4C35-A1E0-1356F63235F6.aa51165d.jpeg";